// src/services/outsourcePersonService.ts
import api from "../api/axiosClient";

const BASE = "/OutsourcePerson";

export const getOutsourcePersons = async () => {
  const res = await api.get(BASE);
  return res.data;
};

export const getArtistOutsourcePersons = async () => {
  const res = await api.get(`${BASE}/artist`);
  return res.data;
};

export const getOutsourcePerson = async (id: number) => {
  const res = await api.get(`${BASE}/${id}`);
  return res.data;
};

export const createOutsourcePerson = async (data: any) => {
  const res = await api.post(BASE, data);
  return res.data;
};

export const updateOutsourcePerson = async (id: number, data: any) => {
  const res = await api.put(`${BASE}/${id}`, data);
  return res.data;
};

export const deleteOutsourcePerson = async (id: number) => {
  const res = await api.delete(`${BASE}/${id}`);
  return res.data;
};
